import { MdBuildCircle } from "react-icons/md";

const translateStatusColor = (status: number | null) => {
    if (status === null) return '#919091'; // Sin datos: gris
    if (status === -1) return '#FF6060'; // Retroceso: rojo
    if (status === 0) return '#EDBC3E'; // Sin cambios: amarillo
    if (status === 1) return '#03D68A'; // Mejora: verde
    if (status === 2) return '#C0C8CC'; // En proceso: gris claro
    return '';
};

const EvaluationStatesCircle = ({
    status,
    size = 4,
}: {
    status: number | null;
    size?: number;
}) => {
    const statusColor = translateStatusColor(status);

    if (status === 2) {
        return <MdBuildCircle color="#C0C8CC" size={size * 1.60} />;
    }

    return (
        <div
            className="flex items-center justify-center rounded-full"
            style={{
                width: `${size}px`,
                height: `${size}px`,
                backgroundColor: statusColor,
            }}
        />
    );
};

export default EvaluationStatesCircle;